<template>

  <div class="loader" :class="type" :style="{height: height}">
    <svg viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" :fill="color" :width="widthIcon"> <!--:height="height"-->
      <circle cx="15" cy="15" r="15">
        <animate attributeName="r" from="15" to="15"
                 begin="0s" dur="0.8s"
                 values="15;9;15" calcMode="linear"
                 repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="1" to="1"
                 begin="0s" dur="0.8s"
                 values="1;.5;1" calcMode="linear"
                 repeatCount="indefinite" />
      </circle>
      <circle cx="60" cy="15" r="9" fill-opacity="0.3">
        <animate attributeName="r" from="9" to="9"
                 begin="0s" dur="0.8s"
                 values="9;15;9" calcMode="linear"
                 repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="0.5" to="0.5"
                 begin="0s" dur="0.8s"
                 values=".5;1;.5" calcMode="linear"
                 repeatCount="indefinite" />
      </circle>
      <circle cx="105" cy="15" r="15">
        <animate attributeName="r" from="15" to="15"
                 begin="0s" dur="0.8s"
                 values="15;9;15" calcMode="linear"
                 repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="1" to="1"
                 begin="0s" dur="0.8s"
                 values="1;.5;1" calcMode="linear"
                 repeatCount="indefinite" />
      </circle>
    </svg>
  </div>

</template>

<script>
  export default {
    name: 'dots',
    props: {
      color: {
        type: String,
        default: 'rgba(0,0,0,0.5)'
      },
      height: {
        type: String,
        default: '100%'
      },
      widthIcon: {
        type: String,
        default: '60px'
      },
      type: {
        type: String,
        default: 'normal'
      }
    }
  }
</script>

<style scoped>
  .loader{
    /*padding: 2em 1em;*/ 
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .fixed {
    background: rgba(255,255,255,0.5);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/Creating.vue